export default __webpack_public_path__ + "static/app-preview-background-ae58cb249d405a1faf0271c95b3a3e84.jpg";